const autoNgTemplateLoaderTemplate1 = require('./containerProcessesDatatable.html');

angular.module('portainer.docker').component('containerProcessesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '=',
    headerset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
  },
});
